/**
 * network.js — single source of truth for Solana network config.
 *
 * Controlled at build time by the REACT_APP_SOLANA_NETWORK env var,
 * set in docker-compose.yml frontend build args.
 *
 * To roll back to devnet:
 *   1. In docker-compose.yml, change REACT_APP_SOLANA_NETWORK=mainnet → devnet
 *   2. docker compose down && docker compose up -d --build web
 */

export const SOLANA_NETWORK = process.env.REACT_APP_SOLANA_NETWORK || 'devnet';
export const IS_MAINNET = SOLANA_NETWORK === 'mainnet' || SOLANA_NETWORK === 'mainnet-beta';

export const NETWORK_LABEL = IS_MAINNET ? 'Solana Mainnet' : 'Solana Devnet';

/** Full URL to Solana Explorer for a transaction */
export function explorerTxUrl(txHash) {
    return `https://explorer.solana.com/tx/${txHash}${IS_MAINNET ? '' : '?cluster=devnet'}`;
}

/** Full URL to Solscan for a wallet/account */
export function solscanAccountUrl(address) {
    return `https://solscan.io/account/${address}${IS_MAINNET ? '' : '?cluster=devnet'}`;
}

/**
 * Devnet faucet URL for a wallet address.
 * Returns null on mainnet — callers should hide the faucet button when null.
 */
export function faucetUrl(address) {
    if (IS_MAINNET) return null;
    return `https://faucet.solana.com/${address ? `?addr=${address}` : ''}`;
}
